//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS, GameStatus, BetType } from './enum';

export default {
  name: 'BetTakeComponent',
  props: {
    // 当前游戏对象状态
    currentGame: {
      type: Object,
      default: null
    },
    // 是否可以结算/提取 (对应 chickenRoadState.canEndGame)
    canEndGameProp: {
      type: Boolean,
      default: true
    },
    // 是否正在结算中 (对应 chickenRoadState.isEndingGame)
    isEndingGame: {
      type: Boolean,
      default: false
    },
    // 是否在播放动画中 (对应 chickenRoadState.isAnimating)
    isAnimating: {
      type: Boolean,
      default: false
    },
    // 状态中直接计算好的潜在赢额 (可选)
    statePotentialWin: {
      type: Number,
      default: null
    },
    // 下注类型: BALANCE | INVENTORY
    betType: {
      type: String,
      default: BetType.BALANCE
    },
    // 主余额下注金额
    betAmountUsd: {
      type: Number,
      default: 0
    },
    // 背包物品下注金额
    selectedInventoryAmountUsd: {
      type: Number,
      default: 0
    },
    // 选中的游戏难度模式
    selectedMode: {
      type: [String, Number],
      default: 'EASY'
    },
    // 各模式最大倍率映射表
    maxMultipliers: {
      type: Object,
      default: () => MAX_MULTIPLIERS
    },
    // 主播模式标记
    streamerMode: {
      type: Boolean,
      default: false
    },
    // 禁用动画
    disableAnimations: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 判断是否可进行结算
    canEndGame() {
      if (!this.isGameInProgress) {
        return false;
      }
      return this.canEndGameProp;
    },

    // 按钮禁用状态
    disabled() {
      return !this.canEndGame || this.isEndingGame || this.isAnimating;
    },

    // 游戏是否失败
    isGameLost() {
      return this.currentGame && this.currentGame.status === GameStatus.LOST;
    },

    // 游戏是否在进行中
    isGameInProgress() {
      const game = this.currentGame;
      return !!(
        game &&
        (game.status === GameStatus.IN_PROGRESS || game.status === GameStatus.WON) &&
        game.currentStep > 0
      );
    },

    // 游戏未开始
    isGameNotStarted() {
      return !this.currentGame;
    },

    // 游戏开始但未走任何步数
    isGameStartedWithoutSteps() {
      const game = this.currentGame;
      return !!(
        game &&
        game.status === GameStatus.IN_PROGRESS &&
        game.currentStep === 0
      );
    },


    // 计算潜在赢额
    potentialWin() {
      if (this.currentGame) {
        const currentStep = this.currentGame.currentStep || 0;
        if (currentStep <= 0) {
          return 0;
        }

        // 下注金额（优先取服务端返回的 currentGame.amount，兜底取前端输入的金额）
        const betAmount = this.currentGame.amount
          ? parseFloat(this.currentGame.amount)
          : (this.betType === BetType.BALANCE ? this.betAmountUsd : this.selectedInventoryAmountUsd);

        // 获取当前步数对应的倍率
        let multiplier = 1;
        const stepIndex = currentStep - 1;
        const stepData = this.currentGame.steps && this.currentGame.steps[stepIndex];

        if (stepData && stepData.coefficient) {
          multiplier = parseFloat(stepData.coefficient);
        } else if (this.currentGame.ratio) {
          multiplier = parseFloat(this.currentGame.ratio);
        }

        return betAmount * multiplier;
      }

      const multiplier = this.maxMultipliers[this.selectedMode] || 1;
      let betAmount = 0;

      if (this.betType === BetType.BALANCE) {
        betAmount = this.betAmountUsd;
      } else if (this.betType === BetType.INVENTORY) {
        betAmount = this.selectedInventoryAmountUsd;
      }

      return betAmount * multiplier;
    },

    // 格式化输出两位小数
    formattedPotentialWin() {
      return typeof this.potentialWin === 'number'
        ? this.potentialWin.toFixed(2)
        : '0.00';
    },

    // 结算按钮显示文字
    buttonText() {
      if (this.potentialWin > 0) {
        return '领取';
      }
      return '';
    }
  },
  methods: {
    // 点击提取/结束游戏处理
    handleEndGame() {
      if (this.disabled) {
        return;
      }

      // 向上层组件抛出提取事件
      this.$emit('end-game');
    }
  }
};
